import { Form } from 'antd';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { SimulateAssessmentEntity } from 'domain/entities/SimulateEntity';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import FormSimulateSale from './components/FormSimulateSale';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
type props = {
    simulateUseCase: SimulateUseCaseInterface;
    propertyUseCase: PropertyUseCaseInterface;
};
const CU05801Page = ({ simulateUseCase, propertyUseCase }: props) => {
    const { listedPropertyId } = useParams();
    const dispatch = useDispatch();

    const [form] = Form.useForm();
    const [simulateDetail, setSimulateDetail] = useState<SimulateAssessmentEntity>();
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [option, setOption] = useState<any>([]);
    const navigate = useNavigate();
    useEffect(() => {
        if (listedPropertyId) {
            getSimulateAssessmentDetail();
        }
    }, []);
    const getSimulateAssessmentDetail = async () => {
        const params = {
            listedPropertyId: Number(listedPropertyId || 0),
        };
        try {
            dispatch(startFetching());
            const response = await simulateUseCase.getSimulateAssessment(params);
            const loanInstitutionResponse = await simulateUseCase.getSimulateLoadFinancial('1');
            if (response) {
                setSimulateDetail(response.result);
                if (!response.result.personalFunds) {
                    form.setFieldValue(
                        'personalFunds',
                        commonHelpers.formatNumberMoney(
                            (response.result.bidPrice * Number(response.result.fundDefault)) / 100,
                        ),
                    );
                } else {
                    form.setFieldValue(
                        'personalFunds',
                        commonHelpers.formatNumberMoney(response.result.personalFunds),
                    );
                }

                setPurchasePrice(response.result.bidPrice);
            }
            if (loanInstitutionResponse) {
                const data = loanInstitutionResponse.results.map((item: any) => {
                    return {
                        label: item.financialInstitutionNameDisp,
                        value: item.loanFinancialInstitutionCode,
                    };
                });
                setOption(data);
            }
        } catch (e) {
            navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`);
        } finally {
            dispatch(completeFetching());
        }
    };
    return (
        <div className="cu-058-01-wrapper">
            <PageTitle title="キャッシュフローシミュレーション" />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <div>
                    <FormSimulateSale purchasePrice={purchasePrice} service={simulateUseCase} propertyUseCase={propertyUseCase} />
                </div>
            </section>
        </div>
    );
};

export default CU05801Page;
